// components/promotions/priceSyncReason.js
//
// Why one pushed price did not land, as the promotion form's price-sync banner
// says it. The backend sends a code (`PromotionPriceBulkShard.REASON_*`) and,
// when the store gave one, the store's own message — shown verbatim, since it
// names the actual cause in words this table cannot know.

const REASON_KEY = {
  rejected: 'promotions.priceSyncReason.rejected',
  not_confirmed: 'promotions.priceSyncReason.notConfirmed',
};

/**
 * @param {{reason: string, channel_message: string|null}} failedItem
 *   one entry of the payload's `price_sync.failed_items`
 * @param {Function} t
 * @returns {string}
 */
export function priceSyncFailureReason({ reason, channel_message: channelMessage }, t) {
  if (channelMessage != null) return channelMessage;
  const key = REASON_KEY[reason];
  if (!key) {
    throw new Error(`price sync: unknown failure reason ${JSON.stringify(reason)}`);
  }
  return t(key);
}
